import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "../../../../Application/slices/createFetchingItemsSlice";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";
import { type PackResourceItem } from "../../types/state";
import { type RootState } from "../../../../Application/globaltypes/redux";

export interface PackPricingTypesState extends FetchingItemsState<PackResourceItem> {}

const initialState: PackPricingTypesState = {
  items: [],
  itemsCount: 0,
  isLoading: false,
  error: undefined,
};

const packPricingTypeSlice = createFetchingItemsSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.Licensing,
    entity: ReducerEntityPrefixTypes.PackPricingTypes,
    name: "PackPricingTypes",
  },
  initialState,
  reducers: {},
});

export const { fetchBegin, fetchSuccess, fetchFailure, reset } = packPricingTypeSlice.actions;

export const packPricingTypesSelector = (state: RootState) => state.packs.packPricingTypes.items;

export default packPricingTypeSlice.reducer;
export type packTrialPriodsSliceType = ReturnType<typeof packPricingTypeSlice.reducer>;
